
import EsaedroResourceFilter from '../Models/EsaedroResourceFilter';
import ResourceField from '../Models/ResourceField';
import React from 'react'
import moment from 'moment'

export function isFilterable(objToFilter: any, filter: EsaedroResourceFilter): boolean {
    // Forse sto metodo non serve... 
    if (filter.FieldName in objToFilter) return true

    return false
}

export function renderGridObject(field: ResourceField, item: any, index: number, totalSize: number, totalFields: number): any {
    // Calcolo la percentuale sulla base di fieldSize e totalSize e poi la imposto come larghezza ai campi
    let margin = 50
    totalSize = totalSize+margin*totalFields
    var cellWidth: string = (field.Field_Size+margin)/totalSize*100 + '%'

    if (field.FieldName == "num_giorno" ) {
        switch(item[field.FieldName]) {
            case 1:
                return (
                    <td style={{width: cellWidth}} key={index}>Lunedi</td>
                )
            case 2:
                return (
                    <td style={{width: cellWidth}} key={index}>Martedi</td>
                )
            case 3:
                return (
                    <td style={{width: cellWidth}} key={index}>Mercoledi</td>
                )
            case 4:
                return (
                    <td style={{width: cellWidth}} key={index}>Giovedi</td>
                )
            case 5:
                return (
                    <td style={{width: cellWidth}} key={index}>Venerdi</td>
                )
            case 6:
                return (
                    <td style={{width: cellWidth}} key={index}>Sabato</td>
                )
            case 7:
                return (
                    <td style={{width: cellWidth}} key={index}>Domenica</td>
                )
        }
    }

    switch (field.Field_Type) {
        case 1:
            if (item[field.FieldName])
                return (
                    <td style={{width: cellWidth}} key={index}>True</td>
                )
                else return (
                    <td style={{width: cellWidth}} key={index}>False</td>
                )
        case 2:
            if (item[field.FieldName])
                return (
                    <td style={{width: cellWidth}} key={index}>True</td>
                )
                else return (
                    <td style={{width: cellWidth}} key={index}>False</td>
                )
        // Gestisco i DateTime
        case 4:
        case 15:
        case 33:
            return (
                <td style={{width: cellWidth}} key={index}>{moment(item[field.FieldName]).format("DD/MM/YYYY hh:mm")}</td>
            )
        // Gestisco i Date
        case 31:
            return (
                <td style={{width: cellWidth}} key={index}>{moment(item[field.FieldName]).format("DD/MM/YYYY")}</td>
            )
        default:
            return (
                <td style={{width: cellWidth}} key={index}>{item[field.FieldName]}</td>
            )
    }
}

export interface EsaedroChangePasswordObject {
    oldPassword: string,
    newPassword: string,
    confirmPassword: string 
}
    
    